<span class="landing-hero-word-first-part">{{ 'appetite_for' | translate }}</span>
<span *ngFor="let word of words" [@fadeWord]="word === currentWord" class="landing-hero-word">
  {{ word }}
</span>
<br />
<span>{{ 'order_now' | translate }}</span>
